
















































import _ from 'lodash'
import { PERMISSIONS } from '@/store/share/constants'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State, Mutation, Action } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import { UserWithKey } from '@/types/user'
import { Maybe } from '@/types/general'
import { EDITOR_SET_SHARING, ENTRY_UPDATE } from '@/store/editor/constants'

import SharePeer from './SharePeer.vue'
import ShareAddPeer from './ShareAddPeer.vue'
import ShareLinks from './ShareLinks.vue'

/**
 * Share options panel
 *
 * Allows viewing, granting and revoking permissions of other users for
 * the current editor entry
 */
@Component({ components: { SharePeer, ShareAddPeer, ShareLinks }, name: 'share-panel' })
export default class SharePanel extends Vue {
    @Prop({ type: Boolean, default: true })
    collapsed!: boolean

    /**
     * Current editor entry
     */
    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    /**
     * List of users who have access
     */
    @State((state: RootState) => state.share.peers)
    peers!: UserWithKey[]

    /**
     * Enable or disable sharing
     */
    @Mutation(EDITOR_SET_SHARING)
    setSharing!: (value: boolean) => void

    /**
     * Sync entry data with the API
     */
    @Action(ENTRY_UPDATE)
    updateEntry!: () => Promise<void>

    /**
     * Current user's permission name
     */
    get permission(): string {
        return this.entry.permission
    }

    /**
     * Whether the current user is able to enable/disable sharing
     */
    get canToggle(): boolean {
        return this.permission === 'creator' || this.permission === 'private'
    }

    /**
     * Whether sharing is enabled for the entry
     */
    get shareEnabled(): boolean {
        return this.permission !== 'private'
    }

    get orderedPeers(): UserWithKey[] {
        return _.orderBy(this.peers, peer => PERMISSIONS[peer.pivot.permission].position, 'desc')
    }

    get isLogin(): boolean {
        return this.entry.schema !== 'vault'
    }

    /**
     * Enable or disable sharing
     */
    setShare(value: boolean): void {
        this.setSharing(value)
        this.updateEntry()
    }
}
